// Copied from chakra-ui theme
// https://chakra-ui.com/docs/styled-system/theme#z-index-values
export default {
  hide: -1,
  auto: 'auto',
  base: 0,
  docked: 100,
  dropdown: 1000,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800,
};
